module.exports = __webpack_public_path__ + "static/media/car-tilt.62db7223.svg";